/* eslint-disable no-nested-ternary */
import React from 'react';
import { ListItemButton } from '@mui/material';
import { Typography } from "../Typography/index.js";
import { Box } from "../Box/index.js";
import { COLOR_VARIANTS } from "../../theme/palette.theme/index.js";
import { TYPOGRAPHY_VARIANT } from "../../theme/typography.theme/index.js";
import { color } from "../../utils/index.js";
var APPEARANCES = {
  SINGLELINE: 'singleLine',
  SINGLELINEWRAP: 'singleLineWrap',
  DOUBLELINE: 'doubleLine',
  TRIPLELINE: 'tripleLine'
};
var PLATFORM = {
  DESKTOP: 'desktop',
  MOBILE: 'mobile'
};
export var Cell = function Cell(_ref) {
  var appearance = _ref.appearance,
    platform = _ref.platform,
    trailingIcon = _ref.trailingIcon,
    leadingIcon = _ref.leadingIcon,
    title = _ref.title,
    primaryText = _ref.primaryText,
    secondaryText = _ref.secondaryText,
    tripleLineText = _ref.tripleLineText,
    customElement = _ref.customElement,
    trailingText = _ref.trailingText,
    isDisabled = _ref.isDisabled,
    isSelected = _ref.isSelected,
    addPadding = _ref.addPadding,
    addSeparator = _ref.addSeparator,
    onClick = _ref.onClick,
    testId = _ref.testId,
    textDirections = _ref.textDirections,
    isNotClickable = _ref.isNotClickable;
  return /*#__PURE__*/React.createElement(ListItemButton, {
    className: "__ds__comp",
    "data-testid": testId,
    disabled: isDisabled,
    selected: isSelected,
    onClick: onClick,
    sx: {
      padding: addPadding ? '0 16px' : 0,
      cursor: isNotClickable ? 'unset' : 'pointer',
      '&:before': {
        content: '""',
        position: 'absolute',
        left: appearance === APPEARANCES.SINGLELINEWRAP ? '0px' : !addPadding ? '40px' : '60px',
        bottom: 0,
        height: '15px',
        width: appearance === APPEARANCES.SINGLELINEWRAP ? '100%' : !addPadding ? 'calc( 100% - 48px)' : 'calc( 100% - 80px)',
        borderBottom: addSeparator ? "1px solid ".concat(color(COLOR_VARIANTS.GAINSBORO)) : ''
      },
      '&:hover': {
        background: isNotClickable ? 'none' : color(COLOR_VARIANTS.GHOSTWHITE)
      },
      '&.MuiListItemButton-root.Mui-selected': {
        background: color(COLOR_VARIANTS.AQUA10),
        border: platform === PLATFORM.DESKTOP ? "1px solid ".concat(color(COLOR_VARIANTS.AQUA100)) : ''
      }
    }
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      width: '100%',
      display: 'flex'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      width: '100%',
      display: 'flex',
      padding: '18px 0',
      flexDirection: 'column'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: 'flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(React.Fragment, null, appearance !== APPEARANCES.SINGLELINEWRAP && leadingIcon && /*#__PURE__*/React.createElement(Box, {
    sx: {
      background: 'none',
      paddingRight: '16px',
      display: 'flex'
    }
  }, leadingIcon), /*#__PURE__*/React.createElement(Box, {
    sx: {
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(React.Fragment, null, title && /*#__PURE__*/React.createElement(Typography, {
    variant: TYPOGRAPHY_VARIANT.CAPTIONREG,
    component: "h2",
    sx: {
      color: color(COLOR_VARIANTS.GREYCHATEAU)
    },
    direction: textDirections === null || textDirections === void 0 ? void 0 : textDirections.primaryText
  }, title), /*#__PURE__*/React.createElement(Typography, {
    variant: TYPOGRAPHY_VARIANT.BODY2,
    component: "h2",
    sx: {
      color: color(COLOR_VARIANTS.MINESHAFT)
    },
    direction: textDirections === null || textDirections === void 0 ? void 0 : textDirections.primaryText
  }, primaryText), secondaryText && /*#__PURE__*/React.createElement(Typography, {
    variant: TYPOGRAPHY_VARIANT.CAPTIONREG,
    component: "h2",
    sx: {
      color: color(tripleLineText ? COLOR_VARIANTS.MINESHAFT : COLOR_VARIANTS.GREYCHATEAU)
    },
    direction: textDirections === null || textDirections === void 0 ? void 0 : textDirections.secondaryText
  }, secondaryText), tripleLineText && /*#__PURE__*/React.createElement(Typography, {
    variant: TYPOGRAPHY_VARIANT.CAPTIONREG,
    component: "h2",
    sx: {
      color: color(COLOR_VARIANTS.GREYCHATEAU)
    },
    direction: textDirections === null || textDirections === void 0 ? void 0 : textDirections.tripleLineText
  }, tripleLineText))))), /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: 'flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(React.Fragment, null, trailingText && /*#__PURE__*/React.createElement(Typography, {
    variant: TYPOGRAPHY_VARIANT.CAPTIONREG,
    component: "div",
    sx: {
      color: color(COLOR_VARIANTS.GREYCHATEAU),
      marginRight: trailingIcon ? '14px' : '0'
    }
  }, trailingText), trailingIcon))), customElement && /*#__PURE__*/React.createElement(Box, {
    sx: {
      width: 'auto',
      paddingLeft: '43px'
    }
  }, customElement))));
};